import { createAction, props } from '@ngrx/store';
import {
  ErrorModel,
  SubCpoFilterParametersResponse,
  SubCpoListItemResponsePagedResponse,
} from '../../../core/cms-api/models';
import { SubCpoFilter } from './billing.suboperators.models';

export const initSuboperators = createAction('[BillingSuboperators] Init');

export const loadSubCpos = createAction('[BillingSuboperators] Load sub CPOs');
export const loadSubCposSuccess = createAction(
  '[BillingSuboperators] Load sub CPOs success',
  props<{ response: SubCpoListItemResponsePagedResponse }>(),
);
export const loadSubCposFailure = createAction(
  '[BillingSuboperators] Load sub CPOs failure',
  props<{ error: ErrorModel }>(),
);

export const loadSubCpoFilterParameters = createAction(
  '[BillingSuboperators] Load filter parameters',
);
export const loadSubCpoFilterParametersSuccess = createAction(
  '[BillingSuboperators] Load filter parameters success',
  props<{ filterParameters: SubCpoFilterParametersResponse }>(),
);
export const loadSubCpoFilterParametersFailure = createAction(
  '[BillingSuboperators] Load filter parameters failure',
  props<{ error: ErrorModel }>(),
);

export const changeSubCpoFilter = createAction(
  '[BillingSuboperators] Change filter',
  props<{ filter: SubCpoFilter }>(),
);
export const changeSubCpoFilterSuccess = createAction(
  '[BillingSuboperators] Change filter success',
);

export const changeSubCpoPagination = createAction(
  '[BillingSuboperators] Change pagination',
  props<{ pageIndex: number; pageSize: number }>(),
);
export const changeSubCpoPaginationSuccess = createAction(
  '[BillingSuboperators] Change pagination success',
);

export const reinviteSubCpoToOnboarding = createAction(
  '[BillingSuboperators] Reinvite to onboarding',
  props<{ subCpoId: string }>(),
);
export const reinviteSubCpoToOnboardingSuccess = createAction(
  '[BillingSuboperators] Reinvite to onboarding success',
);
export const reinviteSubCpoToOnboardingFailure = createAction(
  '[BillingSuboperators] Reinvite to onboarding failure',
  props<{ error: ErrorModel }>(),
);

export const blockSubCpo = createAction(
  '[BillingSuboperators] Block sub CPO',
  props<{ subCpoId: string }>(),
);
export const blockSubCpoSuccess = createAction('[BillingSuboperators] Block sub CPO success');
export const blockSubCpoFailure = createAction(
  '[BillingSuboperators] Block sub CPO failure',
  props<{ error: ErrorModel }>(),
);
